import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from './../../shared/models/api-response.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TravelersService {

  constructor(private http: HttpClient) { }

  getAllTravelers() {
    return this.http.get<ApiResponseModel>('api/traveler');
  }

  getTravelerBy_UUID(uuid) {
    return this.http.get<ApiResponseModel>('api/traveler/' + uuid);
  }
}
